import React, { useEffect, useState } from 'react';
import { OfficialIdsStyle } from '../ViewEmployeeStyle';
import {
  DeleteIconBox,
  EditIconBox,
  FlexWrapper,
  GreyText,
  SeeMore
} from '../../../../theme/common_style';
import { DeleteIcon, EditIcon, TrashIconNew } from '../../../../theme/SvgIcons';
import { Skeleton } from 'antd';
import {
  deleteEmployeeRemarksApi,
  getEmployeeRemarksApi
} from '../../../../redux/employee/apiRoute';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { checkPermission } from '../../../../utils/common_functions';
import AddRemarks from '../modals/AddRemarks';
import NoData from '../../../../components/common/NoData';
import ConfirmationModal from '../../../../components/Modal/ConfirmationModal';
import { toast } from 'react-toastify';
import ViewRemarks from '../modals/ViewRemarks';
import dayjs from 'dayjs';
import styled from '@emotion/styled';

const Remarks = () => {
  const [loading, setLoading] = useState(false);
  const [cards, setCards] = useState([]);
  const location = useLocation();
  const { id } = location.state || {};
  const [addModal, setAddModal] = useState(false);
  const [editDetails, setEditDetails] = useState(null);
  const { permissions } = useSelector((state) => state?.userInfo?.data);
  let permissionSection = location?.pathname?.includes('my-profile') ? 'my-profile' : 'Employee';
  const canCreate = checkPermission(permissionSection, 'create', permissions);
  const canDelete = checkPermission(permissionSection, 'del', permissions);
  const canUpdate = checkPermission(permissionSection, 'update', permissions);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);

  const handleGetRemarks = async () => {
    try {
      setLoading(true);
      let res = await getEmployeeRemarksApi(id);
      if (res?.statusCode === 200) {
        setCards(res?.data);
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      setDeleteLoading(true);
      let res = await deleteEmployeeRemarksApi(editDetails?.id);
      if (res?.statusCode === 200) {
        toast.success(res?.message || 'Remark deleted successfully');
        setDeleteModal(false);
        handleGetRemarks();
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
    } finally {
      setDeleteLoading(false);
    }
  };

  useEffect(() => {
    handleGetRemarks();
  }, []);

  return (
    <OfficialIdsStyle>
      {deleteModal && (
        <ConfirmationModal
          open={deleteModal}
          onCancel={() => setDeleteModal(false)}
          title={'Delete Remarks'}
          onSubmit={handleDelete}
          buttonName={'Delete'}
          description={'Are you sure you want to delete this remarks?'}
          iconBG={'#FB4A49'}
          icon={<TrashIconNew />}
          loading={deleteLoading}
        />
      )}
      {addModal && (
        <AddRemarks
          open={addModal}
          onClose={() => setAddModal(false)}
          editDetails={editDetails}
          handleList={handleGetRemarks}
        />
      )}
      {viewModal && (
        <ViewRemarks
          open={viewModal}
          onClose={() => setViewModal(false)}
          editDetails={editDetails}
        />
      )}
      <div className="title">
        <h5>Remarks</h5>
        {canCreate && (
          <p
            onClick={() => {
              setAddModal(true);
              setEditDetails(null);
            }}>
            + Add Remark
          </p>
        )}
      </div>
      {loading ? (
        <RemarkGrid>
          <div className="card">
            <Skeleton active title={false} paragraph={{ rows: 5 }} />
            <div style={{ marginTop: 16 }}>
              <Skeleton.Button active block style={{ height: 40 }} />
            </div>
          </div>
          <div className="card">
            <Skeleton active title={false} paragraph={{ rows: 5 }} />
            <div style={{ marginTop: 16 }}>
              <Skeleton.Button active block style={{ height: 40 }} />
            </div>
          </div>
          <div className="card">
            <Skeleton active title={false} paragraph={{ rows: 5 }} />
            <div style={{ marginTop: 16 }}>
              <Skeleton.Button active block style={{ height: 40 }} />
            </div>
          </div>
        </RemarkGrid>
      ) : (
        <RemarkGrid>
          {cards?.map((el, idx) => (
            <FlexWrapper
              key={idx}
              className="card"
              justify="space-between"
              direction="column"
              align="flex-start"
              gap="16px"
              style={{ minHeight: '176px' }}>
              <FlexWrapper justify="space-between" width="100%">
                <div className="name">
                  <h5>{el?.title}</h5>
                  <p>{dayjs(el?.created_at).format('DD MMM, YYYY, hh:mm A')}</p>
                </div>
                <FlexWrapper gap="5px">
                  {canUpdate && (
                    <EditIconBox
                      canUpdate={canUpdate}
                      onClick={() => {
                        setEditDetails(el);
                        setAddModal(true);
                      }}>
                      <EditIcon />
                    </EditIconBox>
                  )}
                  {canDelete && (
                    <DeleteIconBox
                      canDelete={canDelete}
                      onClick={() => {
                        setEditDetails(el);
                        setDeleteModal(true);
                      }}>
                      <DeleteIcon />
                    </DeleteIconBox>
                  )}
                </FlexWrapper>
              </FlexWrapper>
              <GreyText style={{ textAlign: 'start' }}>
                {el?.remarks?.length > 80 ? `${el.remarks.slice(0, 80)}...` : el?.remarks}
              </GreyText>
              <SeeMore
                onClick={() => {
                  setViewModal(true);
                  setEditDetails(el);
                }}>
                See Full Remark
              </SeeMore>
            </FlexWrapper>
          ))}
        </RemarkGrid>
      )}
      {!loading && cards?.length === 0 && (
        <NoData
          title="No Remarks"
          subTitle="No Remarks created yet kindly create Remarks"
          buttonText={canCreate ? '+ Add Remark' : null}
          handleBtn={
            canCreate
              ? () => {
                  setAddModal(true);
                  setEditDetails(null);
                }
              : null
          }
          height={'350px'}
        />
      )}
    </OfficialIdsStyle>
  );
};

export default Remarks;
const RemarkGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 16px;
  gap: 12px;

  @media (max-width: 968px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 668px) {
    grid-template-columns: repeat(1, 1fr);
  }

  .card {
    width: 100%;
    padding: 15px;
    background: #ffffff;
    border-radius: 6px;

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .name {
      h5 {
        font-family: 'Plus Jakarta Sans';
        font-weight: 700;
        font-size: 18px;
        color: #111111;
        margin: 0;
        text-align: left;
      }
      p {
        font-family: 'Plus Jakarta Sans';
        font-weight: 600;
        font-size: 14px;
        color: ${({ theme }) => theme.primaryColor};
        margin: 0;
        text-align: left;
        margin-top: 4px;
      }
    }
  }

  .textarea {
    margin-top: 16px;
  }
`;
